export const initLayers = (cookie: Record<string, string>) => {
  const basket = cookie.cartInfo?.split(';').map(splitByKey) ?? [];
  const shoppingList = cookie.shoppingList?.split(';').map(splitByKey) ?? [];

  window.layers = {
    shoppingList: {
      getShoppingList: () => shoppingList,
    },
    basket: {
      getBasket: () => basket,
    },
  };
};

export function splitByKey(item: string) {
  const [code, quantity] = item.split(':');
  return {
    code,
    quantity: Number(quantity),
  };
}
